module.exports = __webpack_public_path__ + "static/img/secure-payment.d639a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/secure-payment.png
// module id = yXFm
// module chunks = 1